<template>
    <v-col cols="12" class="SystemContact mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                <v-row >
                        <v-col>
                            <h2 class="font-weight-medium text-center title-reports my-6">Formulario de <span class="color-blue">Contacto</span></h2>
                        </v-col>
                      
                </v-row>
                        <v-row>
                            <v-col class="mx-auto" cols="12" lg="7" xl="5">
                                <v-card class="elevation-0 report-detail mx-auto pa-8" min-height="600"  >
                                    <v-row>
                                        <v-col>
                                            <v-text-field
                                                label="Nombre Completo"
                                                placeholder="Ingrese su nombre"
                                                filled
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                label="Email"
                                                placeholder="Ingrese su email"
                                                filled
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                label="Telefono"
                                                placeholder="Ingrese su telefono"
                                                filled
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-text-field
                                                label="Nombre de la empresa"
                                                placeholder="Ingrese nombre de empresa"
                                                filled
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-textarea
                                                name="input-7-1"
                                                label="Comentario"
                                                placeholder=""
                                                dense
                                                hint="maximo 200 caracteres"
                                                ></v-textarea>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-btn
                                                class="btn-report-detail"
                                            >
                                                        Enviar
                                            </v-btn>
                                        </v-col>
                                    </v-row>

                                </v-card>
                            </v-col>
                        </v-row>        
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>
<style lang="scss">

.v-expansion-panel{
    background: #F2F2F2 !important;
    border-radius: 4px;
}
.v-expansion-panel-content{
    border: 1px solid #F2F2F2;
    background-color: #ffffff !important;
    }
.color-blue{
    color:#0172C0;
}
.Contact{
     .v-input{
         .v-input__control{
                height:62px !important;
                .v-text-field__slot{
                    padding-bottom:6px !important;
                }
        }
     }   
     .v-textarea{
        .v-input__control{
                height: inherit !important;
        }
    }

    .v-input input {
        font-size: .9em;
    }

    .v-input .v-label {
    font-size: 0.8em;
}
}
    

</style>
<script>
    export default {
        name: 'SystemContact',
        created: function () {
            //this.$emit('SetcolorMenu', '#7F03BB');
        }
    }
</script>